import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      stroke: "#333",
      d: "M17.357 16.644v.001a.5.5 0 0 1 0 .71l-.002.003a.5.5 0 0 1-.71 0v-.001l-3.39-3.4-.314-.315-.35.275a7.42 7.42 0 0 1-4.59 1.583H8A7.5 7.5 0 1 1 15.5 8a7.42 7.42 0 0 1-1.583 4.591l-.274.35.314.313zM2.595 4.39a6.5 6.5 0 1 0 10.81 7.222A6.5 6.5 0 0 0 2.595 4.39Z"
    }, null, -1)
  ])))
}
export default { render: render }